"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var Details = function Details(_ref) {
  var children = _ref.children,
      summaryContent = _ref.summaryContent,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "summaryContent"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var handleToggle = function handleToggle() {
    setIsOpen(!isOpen);
  };

  return /*#__PURE__*/_react.default.createElement("details", (0, _extends2.default)({
    onToggle: handleToggle
  }, rest), _react.default.cloneElement(summaryContent, {
    isOpen: isOpen
  }), isOpen ? children : null);
};

Details.propTypes = {
  /**
   * The content that is hidden.
   * Must be flow content in order to be valid HTML: https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/Content_categories#Flow_content.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * The content that is always visible.
   * To be valid HTML, it can be passed either phrasing content or one heading https://developer.mozilla.org/en-US/docs/Web/HTML/Element/summary.
   */
  summaryContent: _propTypes.default.node.isRequired
};
var _default = Details;
exports.default = _default;